import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { GallerySortNames } from '@sorare/core/src/contexts/config';

// Suppressed outside football because the backend drops the odds sort for other sports rather than
// failing the request, which would leave the grid ordered by something else entirely.
export const startingPredictionSortFor = (sport: Sport): GallerySortNames =>
  sport === Sport.FOOTBALL ? ['Cards On Sale Starting Prediction'] : [];
